import { createContext, useState } from "react";

const TemplateEmailsContext = createContext();
const TemplateEmailsContextProvider = ({ children }) => {
  const [mainLoading, setMainLoading] = useState(false);
  const [routine, setRoutine] = useState("");
  const [header, setHeader] = useState(null);
  const [headerEditor, setHeaderEditor] = useState("");
  const [bodyEditor, setBodyEditor] = useState("");
  const [footer, setFooter] = useState(null);
  const [footerEditor, setFooterEditor] = useState("");
  const [typesList, setTypesList] = useState(null);
  const [headersList, setHeadersList] = useState(null);
  const [footersList, setFootersList] = useState(null);
  const [templateDescription, setTemplateDescription] = useState("");
  const [descriptionHeader, setDescriptionHeader] = useState("");
  const [descriptionFooter, setDescriptionFooter] = useState("");
  const [hiddenCopy, setHiddenCopy] = useState("");
  const [title, setTitle] = useState("");
  const [subject, setSubject] = useState("");
  const [headerHeandle, setHeaderHeandle] = useState("");
  const [footerHeandle, setFooterHeandle] = useState("");
  const [headerSelected, setHeaderSelected] = useState("");
  const [footerSelected, setFooterSelected] = useState("");
  const [templateEmail, setTemplateEmail] = useState("");
  const [tableEmailsItems, setTableEmailsItems] = useState([]);

  return (
    <TemplateEmailsContext.Provider
      value={{
        mainLoading,
        setMainLoading,
        routine,
        setRoutine,
        header,
        setHeader,
        headerEditor,
        setHeaderEditor,
        bodyEditor,
        setBodyEditor,
        footer,
        setFooter,
        footerEditor,
        setFooterEditor,
        typesList,
        setTypesList,
        headersList,
        setHeadersList,
        footersList,
        setFootersList,
        templateDescription,
        setTemplateDescription,
        descriptionHeader,
        setDescriptionHeader,
        descriptionFooter,
        setDescriptionFooter,
        hiddenCopy,
        setHiddenCopy,
        title,
        setTitle,
        subject,
        setSubject,
        headerHeandle,
        setHeaderHeandle,
        footerHeandle,
        setFooterHeandle,
        headerSelected,
        setHeaderSelected,
        footerSelected,
        setFooterSelected,
        templateEmail,
        setTemplateEmail,
        tableEmailsItems,
        setTableEmailsItems,
      }}
    >
      {children}
    </TemplateEmailsContext.Provider>
  );
};

export { TemplateEmailsContextProvider, TemplateEmailsContext };
